import { useState } from "react";
import { Check, IdCard } from "lucide-react";

const FIELDS = [["name", "name", "Ad Soyad"], ["tcKimlik", "taxNo", "T.C. Kimlik No"], ["birthDate", "birthDate", "Doğum tarihi"]];
export const fmtBirth = (s) => (s ? new Date(`${s}T00:00:00`).toLocaleDateString("tr-TR") : "");
export const ageOf = (s) => {
  if (!s) return null;
  const b = new Date(`${s}T00:00:00`), n = new Date();
  return n.getFullYear() - b.getFullYear() - (n < new Date(n.getFullYear(), b.getMonth(), b.getDate()) ? 1 : 0);
};

export function IdOcrCompare({ ocr, current, onApply, applyLabel = "Müşteriye uygula", doneText = "Müşteri bilgileri güncellendi", testPrefix = "id-ocr" }) {
  const rows = FIELDS.filter(([k]) => ocr[k]).map(([k, target, label]) => ({ k, target, label, value: ocr[k], old: current[target] || "" }));
  const [sel, setSel] = useState(() => Object.fromEntries(rows.map((r) => [r.target, r.value !== r.old && (r.target !== "name" || !r.old)])));
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState("");
  if (!rows.length) return <small className="doc-error" data-testid={`${testPrefix}-empty`}>Kimlikten bilgi okunamadı, alanları elle doldurabilirsiniz.</small>;
  const show = (r, v) => (r.target === "birthDate" ? fmtBirth(v) : v);
  const apply = async () => {
    const fields = Object.fromEntries(rows.filter((r) => sel[r.target]).map((r) => [r.target, r.value]));
    if (!Object.keys(fields).length) return;
    setBusy(true);
    try { await onApply(fields); setDone(doneText); } catch (e) { setDone(e?.response?.data?.detail || "Uygulanamadı"); } finally { setBusy(false); }
  };
  return (
    <div className="doc-ocr id-ocr" data-testid={`${testPrefix}-result`}>
      <div className="id-ocr-head"><IdCard size={14} /> Kimlikten okunan bilgiler</div>
      <table className="id-ocr-table">
        <thead><tr><th /><th>Alan</th><th>Mevcut</th><th>Okunan</th></tr></thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.k} className={r.old && r.old !== r.value ? "diff" : ""}>
              <td><input type="checkbox" checked={!!sel[r.target]} disabled={r.old === r.value} onChange={(e) => setSel((s) => ({ ...s, [r.target]: e.target.checked }))} data-testid={`${testPrefix}-check-${r.target}`} /></td>
              <td>{r.label}</td>
              <td className="old" data-testid={`${testPrefix}-old-${r.target}`}>{show(r, r.old) || <em className="dim">boş</em>}</td>
              <td className="new" data-testid={`${testPrefix}-new-${r.target}`}>{show(r, r.value)}{r.old === r.value && <Check size={12} />}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="doc-ocr-actions">
        <button type="button" className="outline-button" onClick={apply} disabled={busy || !Object.values(sel).some(Boolean)} data-testid={`${testPrefix}-apply`}>{busy ? "Uygulanıyor…" : applyLabel}</button>
        {done && <small data-testid={`${testPrefix}-msg`}>{done}</small>}
      </div>
    </div>
  );
}
